import React from "react";
import "./Sidebar.css";
import add_product_icon from "../Assets/Product_Cart.svg";
import list_product_icon from "../Assets/Product_list_icon.svg";
import Orders_product_icon from "../Assets/Orders_Icon.png";
import { Link } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";

const Sidebar = () => {
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="sidebar">
      <Link to="/admin/addproduct" style={{ textDecoration: "none" }}>
        <div className="sidebar-item">
          <img src={add_product_icon} alt="" />
          <p>Add Product</p>
        </div>
      </Link>
      <Link to="/admin/listproduct" style={{ textDecoration: "none" }}>
        <div className="sidebar-item">
          <img src={list_product_icon} alt="" />
          <p>Product List</p>
        </div>
      </Link>

      <Link to="/admin/orders" style={{ textDecoration: "none" }}>
        <div className="sidebar-item">
          <img src={Orders_product_icon} alt="" />
          <p>Orders List</p>
        </div>
      </Link>

      <Link to="/admin/newsletter" style={{ textDecoration: "none" }}>
        <div className="sidebar-item">
          <img
            src="https://cdn-icons-png.flaticon.com/512/561/561127.png"
            alt="Newsletter"
            style={{ width: "32px", height: "32px" }}
          />
          <p>Newsletter</p>
        </div>
      </Link>

      <Link to="/admin/reports" style={{ textDecoration: "none" }}>
        <div className="sidebar-item">
          <img
            src="https://cdn-icons-png.flaticon.com/512/1055/1055672.png"
            alt="Reports"
            style={{ width: "32px", height: "32px" }}
          />
          <p>Reports</p>
        </div>
      </Link>

      <Link to="/admin/createadmin" style={{ textDecoration: "none" }}>
        <div className="sidebar-item">
          <img
            src="https://cdn-icons-png.flaticon.com/512/1077/1077012.png"
            alt="Create Admin"
            style={{ width: "32px", height: "32px" }}
          />
          <p>Create Admin</p>
        </div>
      </Link>

      <Link to="/admin/database-backup" style={{ textDecoration: "none" }}>
        <div className="sidebar-item">
          <img
            src="https://cdn-icons-png.flaticon.com/512/1048/1048953.png"
            alt="Database Backup"
            style={{ width: "32px", height: "32px" }}
          />
          <p>Database Backup</p>
        </div>
      </Link>

      {/* Add a spacer for visual separation */}
      <div style={{ height: 48 }} />

      <div
        className="sidebar-item logout"
        onClick={handleLogout}
        style={{ cursor: "pointer" }}
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/1828/1828471.png"
          alt="Logout"
          style={{ width: "24px", height: "24px" }}
        />
        <p>Logout</p>
      </div>
    </div>
  );
};

export default Sidebar;
